<template>
	<!-- 描述 -->
	<div class="Minister-top information">
		<div class="Minister-top-top Ministerbackground">
			<div class="Minister-top-left Minister-top-color">描述</div>
		</div>
		<div class="information_content">
			<div class="information_input" style="margin-bottom:10px;" >
				<div class="information_Title">
					文字描述
					<el-tooltip placement="right-start" v-show="formData.description">
						<div slot="content" class="el_tip_box">
							{{formData.description}}
						</div>
						<img :src="urlQueImg" class="item_img" alt/>
					</el-tooltip>
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-input
								type="textarea"
								class="width85"
								placeholder="请输入不含表情符号或HTML格式的纯文本"
								v-model="formData.descValue"
								maxlength="5000"
								:autosize="{ minRows: 3, maxRows: 4}"
								show-word-limit
								:disabled="system < 5 || isChakan"
						></el-input>
					</div>
				</div>
			</div>
			<div v-if="isShowJson">
				<div class="information_input" >
					<div class="information_Title">
						JSON丰富描述
						<el-tooltip placement="right-start" v-show="formData.jsonDescription">
							<div slot="content" class="el_tip_box">
								{{formData.jsonDescription}}
							</div>
							<img :src="urlQueImg" class="item_img" alt/>
						</el-tooltip>
					</div>
					<div class="input_el input_span">
						<el-button type="primary" @click="editTuwen"
								   :disabled="system < 5 || isChakan">图文编辑</el-button>
					</div>
				</div>
				<div
						class="information_input"
						style="margin-bottom:10px;"
				>
					<div style="width: 8%">

					</div>
					<div class="input_el input_span" style="margin-left: 9%">
						<div class="input_bot_tip">
							<el-input
									type="textarea"
									class="width85"
									placeholder="请输入JSON字符串"
									v-model="formData.jsonValue"
									maxlength="5000"
									:autosize="{ minRows: 3, maxRows: 4}"
									show-word-limit
									:disabled="system < 5 || isChakan"
							></el-input>
						</div>
					</div>
				</div>
			</div>
			<div v-if="isShowChicun">
				<div class="information_input" >
					<div class="information_Title">
						尺寸表JSON
						<el-tooltip placement="right-start" v-show="formData.chicunDescription">
						<div slot="content" class="el_tip_box">
							{{formData.chicunDescription}}
						</div>
						<img :src="urlQueImg" class="item_img" alt/>
						</el-tooltip>
					</div>
					<div class="input_el input_span">
						<el-button type="primary" @click="editChima"
								   :disabled="system < 5 || isChakan">尺码编辑</el-button>
					</div>
				</div>
				<div
						class="information_input"
						style="margin-bottom:20px;"
				>
					<div style="width: 8%">

					</div>
					<div class="input_el input_span" style="margin-left: 9%">
						<div class="input_bot_tip">
							<el-input
									ref="customTextarea"
									type="textarea"
									class="width85"
									:disabled="system < 5 || isChakan"
									placeholder="请输入尺寸表JSON"
									v-model="formData.chicunValue"
									maxlength="5000"
									:autosize="{ minRows: 3, maxRows: 4}"
									show-word-limit
							></el-input>
						</div>
					</div>
				</div>
			</div>
		</div>
		<fuwenben ref="fuwenben" @changeContent="changeContent"/>
	</div>
</template>
<script>
	import {ajaxPost, Baseurl} from "../../../../api/api/api";
	import fuwenben from "./fuwenben";
	export default {
		name: 'descComp',
		components: {fuwenben},
		data() {
			return {
				//是否为查看
				isChakan:false,
				system:5,
				pageType: '',
				//问号图标的地址
				urlQueImg:require('@/assets/images/wenhao.png'),
				formData:{
					descValue:'',
					description:'',
					//丰富描述提示
					jsonDescription:'',
					jsonValue:'',
					//尺寸表提示
					chicunDescription:'',
					chicunValue:'',
				},
				isShowJson:false,
				isShowChicun:false
			}
		},
		created() {
			this.system = JSON.parse(localStorage.getItem('role')).system
			this.isShowChicun = false
			this.isShowJson = false
		},
		methods: {
			changeContent(type,val){
				if (type=='tuwen'){
					this.formData.jsonValue = val
				} else {
					this.formData.chicunValue = val
				}
			},
			//修改内容
			editDescJson(item,type){
				if (type == 'jianjie'){
					this.formData.description = item
					this.isShowChicun = true
				}
				if (type == 'chicunbiao'){
						this.formData.chicunDescription = item
						this.isShowChicun = true
				}
				if (type == 'jsonFenfu'){
					this.formData.jsonDescription = item
					this.isShowJson = true
				}
			},
			editTuwen(){
				this.$refs.fuwenben.initContent(this.formData.jsonValue,'tuwen')
			},
			editChima(){
				this.$refs.fuwenben.initContent(this.formData.chicunValue,'chicun')
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "../ozon.less";
	.input_bot_tip{
		display: flex;
		flex-direction: column;
	}
</style>
